import React from "react";
import { Pagination } from "react-bootstrap";

const PaginationComponent = ({
  currentPage,
  onPageChange,
  totalPages,
}) => {
  const maxVisiblePages = 5; // Number of page numbers to show

  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber - 1);
  };

  const getVisiblePages = () => {
    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const visiblePages = getVisiblePages();

  return (
    <Pagination>
      <Pagination.First
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 0}
      />
      <Pagination.Prev
        onClick={() => handlePageChange(currentPage)}
        disabled={currentPage === 0}
      />

      {visiblePages.map((page) => (
        <Pagination.Item
          key={page}
          active={currentPage === page}
          onClick={() => handlePageChange(page + 1)}
        >
          {page + 1}
        </Pagination.Item>
      ))}

      <Pagination.Next
        onClick={() => handlePageChange(currentPage + 2)}
        disabled={currentPage === totalPages - 1}
      />
      <Pagination.Last
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages - 1}
      />
    </Pagination>
  );
};

export default PaginationComponent;
